import { useState, useEffect, } from 'react';

export default function useWindowDimensions({ divHeader }) {
  const [dimensionsHeader, setDimensionsHeader] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const updateDimensions = () => {
      if (divHeader?.current) {
        const { width, height } = divHeader?.current?.getBoundingClientRect();
        if(dimensionsHeader.width !== width && dimensionsHeader.height !== height)
          setDimensionsHeader({ width, height });
      }
    };
    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  return dimensionsHeader;
}